import classnames from 'classnames';
import { Loading } from '@stadionhq-v3/base-ui';
import { LoadingTemplateParams } from './loadingTemplate.types';
import styles from './loadingTemplate.module.scss';

const LoadingTemplate = ({
  classNames = [],
  nativeProps = {},
  label,
}: LoadingTemplateParams) => {
  const classes = classnames([styles.loadingTemplate, classNames]);

  return (
    <div {...nativeProps} className={classes}>
      {/* TODO: get a more general key for loading text */}
      <Loading label={label} />
    </div>
  );
};

export default LoadingTemplate;
